import React from "react";
import { ColumnsPanelTrigger } from "@mui/x-data-grid-premium";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import { TableToolbarButton } from "./TableToolbarButton";

export default function ToolbarColumnsButton() {
  return (
    <ColumnsPanelTrigger
      render={
        <TableToolbarButton startIcon={<ViewColumnIcon />}>
          Columns
        </TableToolbarButton>
      }
    />
  );
}
